import skroutzLogo from '../assets/skroutz-logo.svg';
import mosoulisLogo from '../assets/mousoulis-logo.svg';

import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import PersonIcon from '@mui/icons-material/Person';
import Link from '@mui/material/Link';
import { removeToken } from '../util/jwtToken';
import { useAppContext } from '../context/AppContext';

const Header = () => {
  const { isLoggedIn, setIsLoggedIn } = useAppContext();

  return (
    <Box
      display="flex"
      flexWrap="wrap"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      maxWidth="90%"
      mb={4}
    >
      <Box mr={2}>
        <Box display="flex" flexDirection="column" alignItems="end">
          <img src={skroutzLogo} alt="Skroutz Logo" style={{ height: 20, width: 70, marginBottom: 4 }} />
          <img src={mosoulisLogo} alt="Mousoulis Logo" style={{ height: 50, width: 150 }} />
        </Box>
      </Box>

      {isLoggedIn && (
        <Box display="flex" alignItems="center" gap={1}>
          <Avatar
            sx={{
              bgcolor: '#F8FFFB',
              color: '#003300',
            }}
          >
            <PersonIcon fontSize="large" />
          </Avatar>
          <Link
            onClick={() => {
              setIsLoggedIn(false);
              removeToken();
            }}
            // underline="hover"
            sx={{
              color: '#004423',
              fontWeight: 'bold',
              fontSize: '16px',
              '&:hover': {
                cursor: 'pointer',
              },
            }}
          >
            Logout
          </Link>
        </Box>
      )}
    </Box>
  );
};

export default Header;
